import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { JobExecution } from './JobExecution';
import { PagedResponse } from '../paging/PagedResponse';

export class JobExecutionResource extends FBaseService {
  public async getJobExecutions(fiId: string, pagingOptions: any): Promise<PagedResponse> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/director/${fiId}/job-execution`, { params: this.getRequestParams(pagingOptions) },
    );
    const rows: JobExecution[] = response.data.data;
    const size: number = response.data.paging.size;
    return { rows, size };
  }

  getRequestParams = (pagingOptions: any): URLSearchParams => {
    const params = new URLSearchParams();
    params.append('pageSize', pagingOptions.itemsPerPage);
    // Vue datatable defaults to page 1 being first and uses the page number to calculate
    // the pagination values so we subtract 1 from the page number here to get the correct
    // page of data.
    params.append('pageIndex', (pagingOptions.page - 1).toString());
    return params;
  }
}

export default JobExecutionResource;
